import EthereumService from '@/services/ethereum'
import bignumber from '@/utils/bignumber'
export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
  }

  async getTokensBalance (tokens, userAddress) {
    let promiseTasks = []
    for (let token in tokens) {
      const task = new Promise(async (resolve) => {
        let balance
        if (token !== 'ETH') {
          balance = await this.getTokenBalance(userAddress, tokens[token].address, tokens[token].decimals || tokens[token].decimal)
        } else {
          balance = await this.getEthBalance(userAddress)
        }
        tokens[token].balance = bignumber(balance)
        resolve()
      })
      promiseTasks.push(task)
    }
    await Promise.all(promiseTasks)
    return tokens
  }
}



// WEBPACK FOOTER //
// ./src/features/UserAssets/service.js